<template>
    <div class="mainAnnotationGroup flex-level flex-top">
        <div v-if="itemData.avatar">
            <avatar class="icon" :avatar="itemData.avatar" />
        </div>
        <div v-else>
            <div v-if="itemData.icon_url" class="icon">
                <a :href="`/staff/${itemData.ownerid}`">
                    <span class="avatar avatar-picture">
                        <img :src="itemData.icon_url" />
                    </span>
                </a>
            </div>
            <div v-else class="icon" v-html="itemData.icon" />
        </div>
        <div class="mainAnnotationContent">
            <div class="annotationsInfos">
                <div class="title">
                    <a :href="`/staff/${itemData.ownerid}`" v-html="itemData.title" />
                </div>

                <el-dropdown class="fright" v-if="canEdit || canDelete">
                    <a href="javascript:;" @click.prevent
                        ><i class="icon-burger" style="position: inherit"></i
                    ></a>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item v-if="canEdit" @click.native="toggleEditMode()">{{
                                $l10n.__('Modifier')
                            }}</el-dropdown-item>
                            <el-dropdown-item
                                v-if="canDelete"
                                @click.native="deleteAnnot(itemData)"
                                >{{ $l10n.__('Supprimer') }}</el-dropdown-item
                            >
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>

                <div v-if="!editMode">
                    <div
                        class="textAnnot my-2 ellipsis editor-preview rich-text-style"
                        v-html="itemData.annotationHtmlFormated"
                    />
                    <div
                        class="time annotationsInfos__title__time mb-2"
                        v-html="itemData.dateAndLink ? itemData.dateAndLink : itemData.date"
                    />
                    <div
                        class="ttAnnotation"
                        v-if="
                            itemData.timetracking &&
                            (itemData.timetracking.time || itemData.timetracking.service)
                        "
                    >
                        <span
                            >{{ $l10n.__('Timetracking') }}: {{ itemData.timetracking.time }} -
                            {{ $l10n.__('Service') }}: {{ itemData.timetracking.service }}</span
                        >
                    </div>
                </div>

                <el-form
                    v-else
                    ref="updateAnnotationForm"
                    class="mb-0 mt-2"
                    :rules="rules"
                    :model="ruleForm"
                >
                    <RichText
                        v-model="tmpContent"
                        :options="optionsRichText"
                        typeRichText="comment"
                        showAIComponents
                        class="annotations-list-item-richtext"
                        :hash="hash"
                    >
                        <template #actions>
                            <div v-if="itemData.annotation.length !== ''">
                                <CompassButton
                                    label="Annuler"
                                    type="secondary"
                                    size="small"
                                    @click="cancel()"
                                />
                                <CompassButton
                                    label="Confirmer"
                                    type="primary"
                                    size="small"
                                    @click="
                                        submitForm('updateAnnotationForm', 'submitUpdate', {
                                            id: itemData.id,
                                        })
                                    "
                                />
                            </div>
                        </template>
                    </RichText>
                </el-form>
                <div class="fs-2 gray-80 mt-1" v-if="mentionAddedInEditing">
                    {{
                        $l10n.__(
                            "Les notifications ne sont pas envoyées lors d'une édition de commentaire",
                        )
                    }}
                </div>
            </div>
            <div v-if="item['subannots'] && item['subannots'].length > 0" class="commentsContainer">
                <ul class="annotationsList" v-if="item['subannots'].length > 2 && !displayAllAnnot">
                    <li>
                        <div class="mb--3 prelative zi-1">
                            <CompassLink
                                :label="labelDisplayAllAnnot"
                                type="primary"
                                size="medium"
                                @click="toggleAllAnnot()"
                            />
                        </div>
                    </li>
                    <li
                        v-for="(subAnnot, indexSubAnnot) in item['subannots'].slice(
                            item['subannots'].length - 2,
                        )"
                        class="annotationsGroup mx-0"
                        :key="indexSubAnnot"
                    >
                        <annotations-list-item
                            :item="{ datas: subAnnot }"
                            :is-reply="true"
                            @delete="deleteAnnot"
                        />
                    </li>
                </ul>
                <ul v-else>
                    <li
                        v-for="(subAnnot, indexSubAnnot) in item['subannots']"
                        :key="indexSubAnnot"
                        class="annotationsGroup mx-0"
                    >
                        <annotations-list-item
                            :item="{ datas: subAnnot }"
                            :is-reply="true"
                            @delete="deleteAnnot"
                        />
                    </li>
                </ul>
            </div>

            <RichText
                v-if="!isReply"
                v-model="newReply"
                :placeholder="$t.__('common.actions.answer')"
                :options="optionsRichText"
                typeRichText="comment"
                class="annotations-list-item-richtext reply"
                :useStorage="true"
                :refRichText="refRichText"
                showAIComponents
                :hash="hashNewReply"
            >
                <template #actions>
                    <div v-if="newReply.length > 0 && newReply !== '<p></p>'">
                        <CompassButton
                            label="Annuler"
                            type="secondary"
                            size="small"
                            @click="cancelReply()"
                        />
                        <CompassButton
                            label="Confirmer"
                            type="primary"
                            size="small"
                            @click="submitReply"
                        />
                    </div>
                </template>
            </RichText>
        </div>
    </div>
</template>

<script>
import AnnotationsListItem from 'vcomponents/utilities/AnnotationsListItem.vue';
import FormMixin from 'mixins/FormMixins';
import AnnotationValidator from 'mixins/validators/AnnotationValidator';
import AnnotationService from 'Services/Annotations/AnnotationService';
import Avatar from 'vcomponents/utilities/Avatar.vue';
import RichText from 'vcomponents/richtext/RichText.vue';
import { REF_RICH_TEXT_CONTEXT, buildRichTextRef } from 'Services/RichTextRefBuilder.js';
import generateHash from 'Helpers/hashGenerator.js';

export default {
    components: {
        AnnotationsListItem: () => import('vcomponents/utilities/AnnotationsListItem.vue'),
        Avatar,
        RichText,
    },
    mixins: [FormMixin, AnnotationValidator],
    props: {
        item: {
            type: Object,
            required: true,
        },
        isReply: {
            type: Boolean,
            required: false,
            default: false,
        },
        data: {
            type: Object,
            required: false,
            default: () => {},
        },
        corptype: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            rules: {
                timetrackingTime: [{ validator: this.validateTimetracking, trigger: 'blur' }],
                service: [{ validator: this.validateService, trigger: 'blur' }],
            },
            ruleForm: {
                service:
                    this.item['datas'].timetracking && this.item['datas'].timetracking.serviceid
                        ? parseInt(this.item['datas'].timetracking.serviceid)
                        : 0,
                timetrackingTime:
                    this.item['datas'].timetracking && this.item['datas'].timetracking.time
                        ? this.item['datas'].timetracking.time
                        : '',
            },
            timetrackingFormat:
                this.item['datas'].timetracking && this.item['datas'].timetracking.format
                    ? this.item['datas'].timetracking.format
                    : 'HH:mm',
            defaultOptions:
                this.item['datas'].timetracking && this.item['datas'].timetracking.serviceid
                    ? [
                          {
                              id: this.item['datas'].timetracking.serviceid,
                              name: this.item['datas'].timetracking.service,
                          },
                      ]
                    : [],
            displayTimetrackingForm: false,
            tmpContent: '',
            editorEdit: null,
            editMode: false,
            newReply: '',
            displayAllAnnot: false,
            mentionAddedInEditing: false,
            annotationService: new AnnotationService(),
            optionsRichText: [
                'SellsyAI',
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
                'Mention',
            ],
            refRichText: '',
            hash: generateHash(),
            hashNewReply: generateHash(),
        };
    },
    computed: {
        canEdit() {
            return this.itemData.canEdit == 'Y';
        },
        canDelete() {
            return this.itemData.canEdit == 'Y';
        },
        labelDisplayAllAnnot() {
            return this.$l10n.n__(
                'Voir 1 commentaire de plus',
                'Voir %d commentaires de plus',
                this.item['subannots'].length - 2,
                this.item['subannots'].length - 2,
            );
        },
        itemData() {
            return this.item['datas'];
        },
    },
    created() {
        this.refRichText = buildRichTextRef({
            context: REF_RICH_TEXT_CONTEXT.REPLY_NEW,
            linkedid: this.itemData.relatedid,
            linkedtype: this.itemData.relatedtype,
            cardId: this.itemData.id,
        });
    },
    methods: {
        toggleEditMode() {
            this.editMode = !this.editMode;
            if (this.editMode) {
                this.tmpContent = this.itemData.annotation.replace(/\n/gi, '<p></p>');
            }
        },
        toggleTimetrackingForm() {
            this.displayTimetrackingForm = !this.displayTimetrackingForm;
            if (this.displayTimetrackingForm) {
                this.ruleForm.service =
                    this.itemData.timetracking && this.itemData.timetracking.serviceid
                        ? parseInt(this.itemData.timetracking.serviceid)
                        : 0;
                this.ruleForm.timetrackingTime =
                    this.itemData.timetracking && this.itemData.timetracking.time
                        ? this.itemData.timetracking.time
                        : '';
            }
        },
        createReplyWithApiV2Format(data) {
            let owner = data._embed ? data._embed.owner : data.owner;
            let timestamp = new Date(data.updated).getTime() / 1000;
            let date = moment(data.updated);
            let dateFormated = date.calendar(null, { sameDay: "[Aujourd'hui] LT" });
            owner.name = `${owner.firstname} ${owner.lastname}`;

            return {
                annotation: data.description,
                annotationEdit: data.description,
                annotationHtmlFormated: data.description,
                canEdit: 'Y',
                date: dateFormated,
                lastupdatedate: dateFormated,
                id: data.id,
                lastupdatetimestamp: timestamp,
                ownerid: owner.id,
                parentid: data.parent_id,
                relatedid: data.related[0].id,
                relatedtype: data.related[0].type,
                timestamp: timestamp,
                title: owner.name,
                avatar: {
                    value: `${owner.firstname.charAt(0)}${owner.lastname.charAt(0)}`,
                },
            };
        },
        submitReply() {
            this.annotationService
                .createAnnotation(
                    this.newReply,
                    this.linkedid,
                    this.corptype,
                    parseInt(this.itemData.id),
                )
                .then((response) => {
                    if (sessionStorage.getItem(`overview__${this.refRichText}`)) {
                        sessionStorage.removeItem(`overview__${this.refRichText}`);
                    }
                    let reply = this.createReplyWithApiV2Format(response.data);
                    this.newReply = '';
                    if (!this.item.subannots) {
                        Vue.set(this.item, 'subannots', []);
                    }
                    this.item.subannots.push(reply);
                })
                .catch((error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    Push.error(
                        this.$l10n.__(
                            "Une erreur est survenue lors de l'enregistrement du commentaire",
                        ),
                    );
                });
        },
        submitUpdate(payload) {
            this.mentionAddedInEditing = false;

            let timetracking = null;
            if (this.ruleForm.timetrackingTime.length > 0) {
                let a = this.ruleForm.timetrackingTime.split(':'); // split it at the colons
                timetracking = {
                    duration: +a[0] * 60 * 60 + +a[1] * 60 + +a[2],
                    service: this.ruleForm.service,
                };
            }

            this.annotationService
                .updateAnnotation(payload.id, this.tmpContent, timetracking)
                .then((response) => {
                    this.itemData.annotation = response.data.description;
                    this.itemData.annotationHtmlFormated = response.data.description;
                    this.editMode = false;
                    this.displayTimetrackingForm = false;

                    // this.itemData.lastupdatedate = moment().calendar(null,{sameDay: '[Aujourd\'hui] LT'})
                    if (!_.isNil(response.data.timetracking)) {
                        let stringDurationTimetracking = moment()
                            .startOf('day')
                            .second(response.data.timetracking.duration)
                            .format('HH:mm:ss');

                        this.itemData.timetracking = {
                            time: stringDurationTimetracking,
                            service: response.data.timetracking.name,
                            serviceid: response.data.timetracking.service,
                        };
                        this.ruleForm.timetrackingTime = response.data.timetracking.duration
                            ? stringDurationTimetracking
                            : null;
                        this.ruleForm.service =
                            this.itemData.timetracking && this.itemData.timetracking.serviceid
                                ? parseInt(this.itemData.timetracking.serviceid)
                                : [];
                        this.defaultOptions =
                            this.itemData.timetracking && this.itemData.timetracking.serviceid
                                ? [
                                      {
                                          id: this.itemData.timetracking.serviceid,
                                          name: this.itemData.timetracking.service,
                                      },
                                  ]
                                : [];

                        this.timetrackingFormat =
                            response.data.timetracking.duration >= 3600 ? `HH:mm` : `mm`;
                    }
                })
                .catch((err) => {
                    this.errors.setErrors(err.response.data.error.message);
                    Push.error(
                        this.$l10n.__(
                            "Une erreur est survenue lors de l'enregistrement du commentaire",
                        ),
                    );
                });
        },
        cancel() {
            this.mentionAddedInEditing = false;
            this.editMode = false;
            this.displayTimetrackingForm = false;
        },
        cancelReply() {
            this.newReply = '';
        },
        deleteAnnot(payload) {
            this.$emit('delete', payload);
            this.editMode = false;
        },
        toggleAllAnnot() {
            this.displayAllAnnot = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.textAnnot {
    white-space: normal;
}
.rich-text.annotations-list-item-richtext {
    width: 100%;
    &.reply {
        margin: 0 0 var(--spacing-1) 0;
    }
}
.annotationsInfos {
    margin: 0 0 var(--spacing-3);
}
</style>
